import type { ContentStep } from '@cfa/pathway-fe-shared/xp';

import Constants from '@/constants';

import { getPlanStepResourceReference } from '@/routes/TrainingPlans/getPlanStepResourceReference';

export type PlanStepResourceMissingField = 'resource_id' | 'reference';

export interface PlanStepResourceError {
  missing_fields: PlanStepResourceMissingField[];
}

const collectMissingFields = (
  resourceId: string | null,
  reference: ReturnType<typeof getPlanStepResourceReference>,
  referenceId: string | null,
): PlanStepResourceMissingField[] => {
  const missingFields: PlanStepResourceMissingField[] = [];

  if (!resourceId) {
    missingFields.push('resource_id');
  }
  if (!reference || !referenceId) {
    missingFields.push('reference');
  }

  return missingFields;
};

/** Document steps only — returns null when resource and reference IDs are healthy. */
export const classifyPlanStepResourceError = (
  step: ContentStep,
): PlanStepResourceError | null => {
  if (step.type !== Constants.STEP_TYPES.DOCUMENT) {
    return null;
  }

  const resourceId = step.resource?.id ?? null;
  const reference = getPlanStepResourceReference(step);
  const referenceId = reference?.id ?? null;
  const missingFields = collectMissingFields(
    resourceId,
    reference,
    referenceId,
  );

  if (!step.available) {
    return { missing_fields: missingFields };
  }

  if (missingFields.length === 0) {
    return null;
  }

  return { missing_fields: missingFields };
};
